import * as M from "materialize-css";
import { DOM } from "../../../../../../public/js/utils/DOM";
import {FormValidator} from "../../../../../../public/js/utils/Validator/FormValidator";
import {ControlsForm} from "../../../../Form/Form";

export namespace ControlsWelcomeLoginResetControl {

    class Config {
        public static readonly resetFormId = "frm-reset-form";
        public static readonly resetFormSubmitId = "buttonReset";
        public static readonly resetControl = "reset";
        public static readonly resetCallBack = "ResetPassword";
    }

    export class Control {

        public static load() : void {
            this.triggerResetForm();
        }

        private static triggerResetForm() : void {

            const formElement = DOM.Parser.getHtmlElement(Config.resetFormId) as HTMLFormElement;
            const resetButton = DOM.Parser.getHtmlElement(Config.resetFormSubmitId) as HTMLInputElement;
            FormValidator.validateForm({form: formElement, forceSubmitButton: resetButton});
            M.updateTextFields();

            resetButton.addEventListener('click', (event: MouseEvent) => {
                void ControlsForm.Controller.sendFormDataRequest(formElement, {
                    forceDisabledButtons: [resetButton],
                    linkParameters: {component: Config.resetControl, method: Config.resetCallBack, parameters: []},
                    formData: ControlsForm.Controller.getFormData(formElement),
                    event: event,
                    snippetCallback: () => {
                        this.triggerResetForm();
                    }
                })
            });
        }
    }
}